// extracted by mini-css-extract-plugin
export default {"root":"TYSMm","search":"gEZJf","suggest":"UKfJ2","back":"WMONS","form":"bY23q","errorMessage":"raxn_"};